<div class="wrapper">
  <img src="./assets/img/sad-logo.png" alt="">
  <p>Sorry, smth went wrong&#x2768;&#x2768;</p>
  <button class="card__button" *ngIf="!isUserLoggedIn" title="login" (click)="toLoginPage()">login</button>
</div>
